export type CsWhatsappSurface = 'creditsCheckout' | 'plans';

const CS_WHATSAPP_PHONE = '5511936235959';

const CS_WHATSAPP_TEXT_BY_SURFACE: Record<CsWhatsappSurface, string> = {
  creditsCheckout:
    'Quero um plano com mais créditos de consultas jurídicas. Falar com um especialista para saber mais. (Vim da tela de compra de créditos)',
  plans:
    'Quero um plano com mais créditos de consultas jurídicas. Falar com um especialista para saber mais. (Vim da tela de planos)',
};

export const buildCsWhatsappUrl = (surface: CsWhatsappSurface): string => {
  const text = encodeURIComponent(CS_WHATSAPP_TEXT_BY_SURFACE[surface]);
  return `https://api.whatsapp.com/send?phone=${CS_WHATSAPP_PHONE}&text=${text}`;
};

export const openCsWhatsapp = (surface: CsWhatsappSurface): void => {
  window.open(buildCsWhatsappUrl(surface), '_blank', 'noopener,noreferrer');
};
